export default "__VITE_ASSET__629c3b11__"